import React from 'react';
import { Row, Col, Button, Typography, Space } from 'antd';
import { SearchOutlined, CrownOutlined, DatabaseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const Home = () => {
  const navigate = useNavigate();

  const features = [
    {
      title: '智能搜索',
      description: '支持IMDB编号、电影名称、导演等多维度搜索',
      icon: <SearchOutlined style={{ fontSize: '32px', color: '#007AFF' }} />,
      color: '#E3F2FD'
    },
    {
      title: '会员特权',
      description: '解锁无限搜索次数，享受更多高级功能',
      icon: <CrownOutlined style={{ fontSize: '32px', color: '#FF9500' }} />,
      color: '#FFF3E0'
    },
    {
      title: '海量资源',
      description: '收录超过300万部优质电影资源',
      icon: <DatabaseOutlined style={{ fontSize: '32px', color: '#34C759' }} />,
      color: '#E8F5E9'
    }
  ];

  return (
    <div style={{
      padding: '40px 0'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        textAlign: 'center'
      }}>
        <Space direction="vertical" size={80} style={{ width: '100%' }}>
          {/* Hero Section */}
          <div>
            <Title style={{ 
              fontSize: '48px',
              fontWeight: '700',
              background: 'linear-gradient(120deg, #007AFF, #34C759)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              marginBottom: '24px'
            }}>
              电影搜索
            </Title>
            <Paragraph style={{
              fontSize: '20px',
              color: '#666',
              maxWidth: '600px',
              margin: '24px auto'
            }}>
              专业的电影资源搜索平台，为您提供海量优质电影资源
            </Paragraph>
            <Button 
              type="primary" 
              size="large"
              icon={<SearchOutlined />}
              onClick={() => navigate('/search')}
              style={{
                height: '50px',
                padding: '0 40px',
                fontSize: '18px',
                borderRadius: '25px',
                background: '#007AFF',
                border: 'none',
                boxShadow: '0 4px 14px 0 rgba(0, 122, 255, 0.39)'
              }}
            >
              开始搜索
            </Button>
          </div>

          {/* Features Section */}
          <Row gutter={[32, 32]}>
            {features.map((feature, index) => (
              <Col xs={24} sm={8} key={index}>
                <div style={{
                  padding: '40px 24px',
                  textAlign: 'center',
                  height: '100%',
                  background: 'rgba(255, 255, 255, 0.7)',
                  backdropFilter: 'blur(20px)',
                  borderRadius: '20px',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  ':hover': {
                    transform: 'translateY(-5px)',
                    background: 'rgba(255, 255, 255, 0.9)'
                  }
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: feature.color,
                    borderRadius: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px'
                  }}>
                    {feature.icon}
                  </div>
                  <Title level={3} style={{
                    fontSize: '24px',
                    marginBottom: '16px'
                  }}>
                    {feature.title}
                  </Title>
                  <Paragraph style={{
                    fontSize: '16px',
                    color: '#666',
                    margin: 0
                  }}>
                    {feature.description}
                  </Paragraph>
                </div>
              </Col>
            ))}
          </Row>
        </Space>
      </div>
    </div>
  );
};

export default Home; 